import objectSizeOf from 'object-sizeof'

export const objectSize = (stringOrObject: any, sizeCat: `KB` | `MB` | `B` = `B`) => {
  try {
    const size = objectSizeOf(stringOrObject)

    switch (sizeCat) {
    case `B`: {
      return size
    }

    case `KB`: {
      return size / 1024
    }

    case `MB`: {
      return size / 1024 / 1024
    }

    default: {
      return size
    }
    }
  } catch (error) {
    console.warn(`dataSize:FatalErr`, { error })
    return -1
  }
}

/** @deprecated use objectSize instead! */
export const dataSize = objectSize
